import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import { GoogleMap, MarkerF } from '@react-google-maps/api';
import { useRef } from 'react';
import { SuccessPageMapProps } from './SelectedSitesContainer.type';
import { useMemo } from 'react';
import IconMarker from '../../../../public/icon-marker.svg';

const SuccessPageMap = (props: SuccessPageMapProps): JSX.Element => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));
  const mapOptions = useMemo((): google.maps.MapOptions => {
    const base: google.maps.MapOptions = {
      disableDefaultUI: false,
      zoomControl: false,
      cameraControl: true,
      mapTypeControl: true,
      streetViewControl: true,
      fullscreenControl: true,
      gestureHandling: 'auto',
    };
    if (typeof window === 'undefined' || !window.google?.maps?.ControlPosition) {
      return base;
    }
    const { ControlPosition } = google.maps;
    return {
      ...base,
      cameraControlOptions: { position: ControlPosition.RIGHT_BOTTOM },
      streetViewControlOptions: { position: ControlPosition.RIGHT_CENTER },
      fullscreenControlOptions: { position: ControlPosition.RIGHT_TOP },
    };
  }, []);
  const containerStyle = {
    width: '100%',
    height: `100%`,
    maxWidth: '100%',
    borderBottomRightRadius: isDesktop ? '0.5rem' : 0,
    borderTopRightRadius: isDesktop ? '0.5rem' : 0,
  };

  const center = useRef({
    lat: props?.confirmedsitesData?.latitude || 58.3,
    lng: props?.confirmedsitesData?.longitude || -134.43,
  });

  return (
    <Box
      className="success-box-map"
      sx={{
        height: `100%`,
        minHeight: '200px',
      }}
    >
      {typeof window !== 'undefined' && window.google?.maps && (
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={center.current}
          zoom={10}
          options={mapOptions}
        >
          <MarkerF
            position={{
              lat: props?.confirmedsitesData?.latitude,
              lng: props?.confirmedsitesData?.longitude,
            }}
            icon={props?.markerUrl ? props?.markerUrl : <IconMarker></IconMarker>}
          />
        </GoogleMap>
      )}
    </Box>
  );
};

export default SuccessPageMap;
